import React, { useState, useEffect } from "react";
import { Box, Paper } from "@mui/material";
import CalendarWeekView from "../common-components/Calendar/CalendarWeekView";
import { VIEW_MODES } from "../../utils/Constants";
const styles = {
  container: {
    width: "100%",
    mt: 2,
  },
  monthViewPlaceholder: {
    p: 4,
    textAlign: "center",
  },
};
const ShiftCalendar = ({
  view,
  currentDate,
  employees,
  shifts,
  shiftTemplates,
  onAssignShift,
  onDeleteShift,
  onShiftResize,
  onVisibleDateChange,
}) => {
  return (
    <Box sx={styles.container}>
      {view === VIEW_MODES.WEEK ? (
        <CalendarWeekView
          selectedDate={currentDate}
          employees={employees}
          shifts={shifts}
          shiftTemplates={shiftTemplates}
          onAssignShift={onAssignShift}
          onDeleteShift={onDeleteShift}
          onShiftResize={onShiftResize}
          onVisibleDateChange={onVisibleDateChange}
        />
      ) : (
        <Box sx={styles.monthViewPlaceholder}>
          <CalendarWeekView
            selectedDate={currentDate}
            employees={employees}
            shifts={shifts}
            shiftTemplates={shiftTemplates}
            onAssignShift={onAssignShift}
            onDeleteShift={onDeleteShift}
            onShiftResize={onShiftResize}
            onVisibleDateChange={onVisibleDateChange}
          />
        </Box>
      )}
    </Box>
  );
};
export default ShiftCalendar;
